module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_11_1.525638a2.jpeg";